module.exports = __webpack_public_path__ + "img/243.55ab5a43.jpg";